<div class="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
  <div class="flex items-start gap-3 mb-5 md:mb-6">
    <div class="w-1 h-12 bg-[#3D3DF4] rounded-full shrink-0"></div>
    <div class="flex flex-col gap-1.5">
      <h2 class="text-lg sm:text-xl font-bold text-gray-900 dark:text-white leading-tight">Agentes Activos</h2>
      @if (expertCards.length > 0) {
      <span
        class="inline-flex items-center w-fit px-3 py-0.5 rounded-md bg-[#EEF2FF] dark:bg-[var(--color-dark-bg-secondary)] text-xs font-semibold text-[#3D3DF4] dark:text-[#5D5DF6]">
        {{ activeCount }} / {{ totalCount }} Activos
      </span>
      }
    </div>
  </div>

  @if (isLoading && expertCards.length === 0) {
  <div class="py-8 flex items-center justify-center">
    <app-loader label="Cargando agentes..." size="md"></app-loader>
  </div>
  } @else if (expertCards.length === 0) {
  <div class="text-center py-8 text-gray-500 dark:text-gray-400">No tienes agentes asignados.</div>
  } @else {
  <div
    data-onboarding="home-experts"
    class="flex md:grid md:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-4 overflow-x-auto md:overflow-visible -mx-4 px-4 md:mx-0 md:px-0 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
    @for (expert of expertCards; track expert.id ?? expert.title) {
    <div
      class="shrink-0 w-[78vw] max-w-[18rem] md:w-auto md:max-w-none bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-[1.45rem] md:rounded-2xl p-4 flex flex-col transition-all shadow-sm md:shadow-none"
      [class.opacity-50]="expert.disabled" [class.grayscale]="expert.disabled"
      [class.hover:shadow-lg]="!expert.disabled" [class.hover:border-[var(--color-brand-300)]]="!expert.disabled">
      <div class="flex items-center justify-between gap-3 mb-3">
        <div class="w-10 h-10 rounded-xl flex items-center justify-center" [style.background-color]="expert.iconBg">
          <img [src]="expert.iconPath" alt="" class="w-5 h-5">
        </div>
        <span
          class="md:hidden inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider"
          [ngClass]="expert.disabled
            ? 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400'
            : 'bg-green-50 text-green-700 dark:bg-green-900/20 dark:text-green-400'">
          {{ expert.disabled ? 'En espera' : 'Listo' }}
        </span>
      </div>

      <h3 class="text-sm font-semibold text-gray-900 dark:text-white mb-3 leading-5">{{ expert.title }}</h3>

      @if (expert.features && expert.features.length > 0) {
      <ul class="flex-1 space-y-1.5 mb-4">
        @for (feature of expert.features; track feature) {
        <li class="text-xs text-gray-500 dark:text-gray-400 flex items-start gap-1.5">
          <span class="text-gray-400 dark:text-gray-500 mt-0.5">•</span>
          {{ feature }}
        </li>
        }
      </ul>
      } @else {
      <p class="text-xs text-gray-500 dark:text-gray-400 flex-1 mb-4">{{ expert.description }}</p>
      }

      @if (!expert.disabled) {
      <a (click)="onExpertSelected(expert)"
        class="inline-flex items-center justify-between gap-2 mt-auto rounded-xl border border-[var(--color-brand-200)] bg-[var(--color-brand-50)]/70 px-3 py-2.5 text-xs font-semibold text-[var(--color-brand-500)] dark:border-[var(--color-brand-400)]/20 dark:bg-[var(--color-brand-400)]/10 dark:text-[var(--color-brand-300)] hover:text-[var(--color-brand-600)] dark:hover:text-[var(--color-brand-300)] cursor-pointer transition-colors md:border-0 md:bg-transparent md:dark:bg-transparent md:px-0 md:py-0 md:rounded-none md:justify-start md:font-medium">
        <span>Iniciar consulta</span>
        <span aria-hidden="true" class="md:inline">→</span>
      </a>
      } @else {
      <span class="inline-flex items-center justify-center rounded-xl border border-dashed border-gray-200 dark:border-gray-700 px-3 py-2.5 text-xs font-medium text-gray-400 dark:text-gray-500 md:border-0 md:px-0 md:py-0 md:rounded-none md:justify-start">
        No disponible
      </span>
      }
    </div>
    }
  </div>
  }
</div>
